<template>
  <div class="pagemain">
    <!-- <div class="head_box">
      <div class="head_left">
        <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
        <span class="head_title">{{ project_name }} · 项目发薪补发</span>
      </div>
      <div class="head_right"></div>
    </div> -->
     <!-- 菜单 -->
     <my_menu2 page_name="项目发薪补发" back_icon="md-arrow-back" back_type="back"> </my_menu2>
    <div style="height: 45px"></div>
    <div class="card2">
      <div
        v-for="(item, i) in bufa_list"
        :key="i"
        class="card_item"
        @click="click_card(item, i)"
      >
        <div class="card_main">
          <div class="cardfield1">补发id:</div>
          <span>{{ item.bufa_id }}</span>
        </div>
        <div class="card_main">
          <div class="cardfield1">需补发人数:</div>
          <span style="font-weight: 600;color:red;">{{ item.bufa_count }}人</span>
        </div>
        <div class="card_main">
          <div class="cardfield1">已完善人数:</div>
          <span style="font-weight: 600;color:red;">{{ item.wanshan_count }}人</span>
        </div>
        <div class="card_main">
          <div class="cardfield1">补发状态:</div>
          <Tag v-if="item.wanshan_count != item.bufa_count" color="error">待完善</Tag>
          <Tag v-else color="success">已完善</Tag>
        </div>
        <div class="card_main">
          <div class="cardfield1">创建时间:</div>
          <span>{{ item.create_time }}</span>
        </div>
      </div>
    </div>

    <!-- <div class="table_div">
      <Table
        :height="windowHeight - 100"
        :columns="columns"
        :data="audit_list"
        size="small"
        ref="table"
      >
        <template #faxin_file="{ row }">
          <div>
            <span class="down_faxin" @click="down_faxin(row)"
              ><Icon type="ios-cloud-download-outline" />发薪表</span
            >
            <span @click="click_faxin_table(row)" class="down_faxin2"
              ><Icon type="ios-eye-outline" />查看发放数据</span
            >
          </div>
        </template>
        <template #fujian="{ row }">
          <div>
            <span class="down_faxin" @click="click_fujian(row)"
              ><Icon type="ios-eye-outline" />查看附件</span
            >
          </div>
        </template>
        <template #audit_status_fmt="{ row }">
          <div>
            <Tag v-if="row.is_audit == 1" color="primary">通过</Tag>
            <Tag v-if="row.is_audit == 2" color="error">不通过</Tag>
            <Tag v-if="row.is_audit == 0" color="warning">待审核</Tag>
          </div>
        </template>
      </Table>
    </div>

    <Drawer title="附件列表" :closable="true" v-model="fujian_show" width="550">
      <div>
        <div class="fujian_title">图片附件列表</div>
        <Table
          height="200"
          :columns="fujian_colunms"
          :data="img_table"
          size="small"
          ref="table"
        >
          <template #url="{ row }">
            <div>
              <a :href="row.url" target="_black">下载文件</a>
            </div>
          </template>
        </Table>
      </div>
      <div>
        <div class="fujian_title">文件附件列表</div>
        <Table
          height="200"
          :columns="fujian_colunms"
          :data="file_table"
          size="small"
          ref="table"
        >
          <template #url="{ row }">
            <div>
              <a :href="row.url" target="_black">下载文件</a>
            </div>
          </template>
        </Table>
      </div>
    </Drawer>
     -->

    <Drawer title="补发详情" :closable="true" v-model="bufa_show" width="90">
      <div>
        <Alert type="error"
          >提示：发薪信息需要四要素一致！【姓名】【预留手机号】【银行卡号】【身份证号】</Alert
        >
      </div>
      <div>
        <div class="item_0">
          <div class="name">姓名</div>
          <div class="idcard">身份证号</div>
          <div class="money">金额</div>
          <div class="phone">手机号</div>
          <div class="card_number">银行卡号</div>
          <div class="bank_name">银行名称</div>
          <div class="remarks">备注</div>
        </div>
        <div class="item_1_1">
          <div
            v-for="(item, i) in bufa_current_item.bufa_name_list"
            :key="i"
            class="item_1"
          >
            <div class="name">
              {{ item.name
              }}<Icon
                type="ios-create-outline"
                @click="click_editor(item, 'name', i)"
                class="editor"
              />
            </div>
            <div class="idcard">
              {{ item.idcard
              }}<Icon
                type="ios-create-outline"
                @click="click_editor(item, 'idcard', i)"
                class="editor"
              />
            </div>
            <div class="money">
              {{ item.money
              }}<Icon
                type="ios-create-outline"
                @click="click_editor(item, 'money', i)"
                class="editor"
              />
            </div>
            <div class="phone">
              {{ item.phone
              }}<Icon
                @click="click_editor(item, 'phone', i)"
                type="ios-create-outline"
                class="editor"
              />
            </div>
            <div class="card_number">
              {{ item.card_number
              }}<Icon
                @click="click_editor(item, 'card_number', i)"
                type="ios-create-outline"
                class="editor"
              />
            </div>
            <div class="bank_name">
              {{ item.bank_name
              }}<Icon
                @click="click_editor(item, 'bank_name', i)"
                type="ios-create-outline"
                class="editor"
              />
            </div>
            <div class="remarks">
              {{ item.remarks ? item.remarks : "--" }}
            </div>
          </div>
        </div>
        <div class="update_item_div">
          <Button type="primary" @click="update_bufa_info_first()"
           >确认提交补发信息</Button
          >
        </div>
      </div>
    </Drawer>

    <Modal
      v-model="update_text_show"
      title="更新数据"
      :mask-closable="false"
      :footer-hide="true"
      width="350"
    >
      <!-- {{ update_text_item }} -->
      <Input
        v-model="update_text_item[update_key]"
        placeholder="请输入..."
        style="width: 300px"
      />
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
var Base64 = require("js-base64").Base64;
import my_menu2 from "@/component/menu/menu2.vue";

export default {
  components: {my_menu2},
  data() {
    return {
      project_id: "",
      project_name: "",

      bufa_list: [],
      bufa_show: false,
      bufa_current_item: {},

      update_text: "",
      update_index: 0,
      update_key: "",
      update_text_show: false,
      update_text_item: {},
    };
  },
  mounted() {
    var query = this.$route.query;
    if (query) {
      this.project_id = query.project_id;
      this.project_name = query.project_name;
    }
    this.get_bufa_list();
  },

  methods: {
    update_bufa_info_first() {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在更新，只能更新一次，更新后不可以再次操作，是否继续？</p>",
        onOk: () => {
          that.update_bufa_info();
        },
        onCancel: () => {},
      });
    },

    //更新补发信息
    update_bufa_info() {
      var that = this;
      var obj = {
        update_item: this.bufa_current_item,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/faxin_bufa_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_editor(item, key, index) {
      this.update_index = index;
      this.update_text_item = item;
      this.update_key = key;
      this.update_text_show = true;
    },

    click_card(item, i) {
      //   if (item.wanshan_count == item.bufa_count) {
      //     this.$Message.error("已经完善过，不可以再次操作");
      //     return;
      //   }
      this.bufa_current_item = item;
      this.bufa_show = true;
    },

    get_bufa_list() {
      var that = this;
      var obj = {
        payment_id: this.payment_id,
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/faxin_bufa_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.bufa_list = res.data.resp_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.update_item_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.item_1_1 {
  height: calc(100vh - 160px);
  overflow: auto;
  border-bottom: 1px solid #ccc;
}

.item_0 {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e6e4e4;
}

.editor:hover {
  font-size: 16px;
  font-weight: 600;
  color: #0466dd;
  cursor: pointer;
}

.remarks {
  width: 120px;
  font-size: 13px;
}

.name {
  width: 100px;
  font-size: 13px;
}

.idcard {
  width: 200px;
  font-size: 13px;
}

.money {
  width: 120px;
  font-size: 13px;
}

.phone {
  font-size: 13px;
  width: 120px;
}

.card_number {
  width:200px;
  font-size: 13px;
}

.bank_name {
  width: 120px;
  font-size: 13px;
}

.item_1 {
  display: flex;
  align-items: center;
}

.cardfield1 {
  width: 80px;
  flex-shrink: 0;
}

.card_item:hover {
  background: #0466dd;
  color: #fff;
}

.card_main {
  display: flex;
  align-items: center;
}

.card2 {
  display: flex;
  flex-wrap: wrap;
}
.card_item {
  padding: 10px 15px;
  background: #fff;
  margin: 10px;
  font-size: 13px;
  color: #333;
  border-radius: 5px;
  cursor: pointer;
}

.fujian_title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin: 10px;
}

.pagemain {
  background: #ececec;
  min-height: 100vh;
}

.table_div {
  border-radius: 5px;
  margin: 10px;
  padding: 10px;
  background: #fff;
}

.down_faxin {
  margin-right: 10px;
  color: #0466dd;
  cursor: pointer;
}

.down_faxin2 {
  cursor: pointer;
  color: #0466dd;
}

.down_faxin:hover {
  font-weight: 600;
}

.down_faxin2:hover {
  font-weight: 600;
}

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: rgb(79, 135, 58);
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}
</style>
